import React from 'react';
import Pill from './Pill';

/**
 * A row of selectable Pill buttons.
 *
 * Props:
 *   options     — [{ value, label }]
 *   value       — selected value (string) for single-select,
 *                 or array of values for multi-select
 *   onChange    — (newValue) => void
 *   multiSelect — boolean (default false); single-select clears on re-click
 *   variant     — Pill variant used for UNSELECTED options (default 'light');
 *                 selected options always use 'primary', as in reporting's PillList
 *   size        — passed through to Pill ('xs' | 'sm' | 'md' | 'lg' | 'xl' | ...)
 */
export default function PillGroup({
  options = [],
  value,
  onChange,
  multiSelect = false,
  variant = 'light',
  size = 'md',
}) {
  const isSelected = (optionValue) => {
    if (multiSelect) return Array.isArray(value) && value.includes(optionValue);
    return value === optionValue;
  };

  const handleClick = (optionValue) => {
    if (multiSelect) {
      const current = Array.isArray(value) ? value : [];
      const next = current.includes(optionValue)
        ? current.filter(v => v !== optionValue)
        : [...current, optionValue];
      onChange(next);
    } else {
      onChange(value === optionValue ? null : optionValue);
    }
  };

  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
      {options.map(option => (
        <Pill
          key={option.value}
          label={option.label}
          variant={isSelected(option.value) ? 'primary' : variant}
          size={size}
          onClick={() => handleClick(option.value)}
        />
      ))}
    </div>
  );
}
